export default __webpack_public_path__ + "static/media/7.bb4ed0e4.png";